export default __webpack_public_path__ + "static/media/MainMeterECNonActive.24170ef4.svg";